interface GeneratedRecord {
  id?: number;
  document?:string;
  identifier?:string;
  numberingDate?:string;
  importer?:string;
  totalCustomsValueUsd?:string;
  totalNetWeight?:string;
  totalGrossWeight?:string;
  modeOfTransport?:string;
  entryCustoms?:string;
  destinationCustoms?:string;
  imaduni?:string;
  minimumSurcharge?:string;
  mobileSurcharge?:string;
  additionalSurcharge?:string;
  vat?:string;
  vatAdvance?:string;
  qrImage?: string;
  pdfFile?: string;
}

export interface GeneratedRecordItem {
  id?: number;
  serialNumber?:string;
  netWeight?:string;
  grossWeight?:string;
  agreement?:string;
  tariffCode?:string;
  countryOfOrigin?:string;
  commercialUnitQuantity?:string;
  customsValueUsd?:string;
  shipment?:string;
  nomenclatureType?:string;
  productCodeWithinAgreement?:string;
  exemptionMntE?:string;
  countryOfProvenance?:string;
  uvfQuantity?:string;
  recordId?:number;
}

export const formatSerialNumber = (input: string | undefined): string => {
  if (!input) {
    return "Desconocido";
  }
  const number = Number(input);
  if (!isNaN(number)) {
    return number.toString().padStart(4, "0");
  }

  return input;
};

export const newGeneratedRecord = (): GeneratedRecord => {
  return {};
};

export default GeneratedRecord;
